export const SCHEDULE_TRIGGER_EVENT_TYPE = "Schedule.weekdays";

/** Every schedule time is wall-clock time in this zone, whoever the owner is. */
export const SCHEDULE_TRIGGER_TIMEZONE = "America/Chicago";

const FIRST_SLOT_MINUTES = 6 * 60;
const LAST_SLOT_MINUTES = 18 * 60;
const SLOT_STEP_MINUTES = 30;

/**
 * `06:00`, `06:30`, … `18:00` — the only times a schedule may be saved at.
 * The API validates against this list and the Inbox picker offers exactly it.
 */
export const SCHEDULE_TRIGGER_TIMES: readonly string[] = Array.from(
  { length: (LAST_SLOT_MINUTES - FIRST_SLOT_MINUTES) / SLOT_STEP_MINUTES + 1 },
  (_, index) => formatMinutes(FIRST_SLOT_MINUTES + index * SLOT_STEP_MINUTES)
);

function formatMinutes(totalMinutes: number): string {
  const hours = String(Math.floor(totalMinutes / 60)).padStart(2, "0");
  const minutes = String(totalMinutes % 60).padStart(2, "0");
  return `${hours}:${minutes}`;
}
